import { ChangeDetectorRef, Component } from '@angular/core';
import { LanguageRequest, LanguageService } from '../../services/language.service';
import { SwitchService } from '../../services/switch.service';

@Component({
  selector: 'app-languages',
  standalone: false,
  templateUrl: './languages.component.html',
  styleUrl: './languages.component.css'
})
export class LanguagesComponent {

  isModalOpen = false;
  successMessage = '';
  errorMessage = '';

  activeTab: 'all' | 'active' | 'inactive' = 'all';
  searchText = '';

  languageId = 0;
  code = '';
  name = '';
  selectedFile: File | null = null;
  isEnabled: boolean = true;

  languages: any[] = [];

  isEnableSave: boolean = false;
  isEnableUpdate: boolean = false;
  isEnableDelete: boolean = false;

  constructor(
    private languageService: LanguageService,
    private cdr: ChangeDetectorRef,
    private swService: SwitchService
  ) { }

  ngOnInit() {
    this.loadLanguages();
  }

  loadLanguages() {
    this.languageService.getAll().subscribe((res: any) => {
      this.languages = res.data;
      console.log(this.languages);
    });
  }

  setTab(tab: 'all' | 'active' | 'inactive') {
    this.activeTab = tab;
  }

  get filteredLanguages() {
    const keyword = this.searchText.trim().toLowerCase();
    let filtered = this.languages;

    if (this.activeTab === 'active') {
      filtered = filtered.filter(l => l.isEnabled);
    }

    if (this.activeTab === 'inactive') {
      filtered = filtered.filter(l => !l.isEnabled);
    }

    if (!keyword) {
      return filtered;
    }

    return filtered.filter(lang =>
      `${lang.name ?? ''} ${lang.code ?? ''}`
        .toLowerCase()
        .includes(keyword)
    );

  }

  get activeCount(): number {
    return this.languages.filter(l => l.isEnabled).length;
  }

  get inactiveCount(): number {
    return this.languages.filter(l => !l.isEnabled).length;
  }

  toggleStatus(lang: any) {
    lang.isEnabled = !lang.isEnabled;
  }

  openModal() {
    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
  }


  switchEnable() {
    this.swService.switchEnable(this.isEnabled);
  }


  onFileSelected(event: any) {
    this.selectedFile = event.target.files[0];
  }


  visibleButtonControl(eventName: string) {

    this.isEnableSave = false;
    this.isEnableUpdate = false;
    this.isEnableDelete = false;

    if (eventName === 'Add') { this.isEnableSave = true }
    else if (eventName === 'Edit') { this.isEnableUpdate = true }
    else if (eventName === 'Delete') { this.isEnableDelete = true }

  }


  viewData(languageId: number, eventName: string) {

    this.visibleButtonControl(eventName);

    this.languageService.getById(languageId).subscribe({
      next: (res) => {

        if (res.status === "success") {
          this.languageId = languageId;
          this.name = res.data.name;
          this.code = res.data.code;
          this.isEnabled = res.data.isEnabled;
          this.openModal();
        } else {
          this.errorMessage = res.message;
        }

        setTimeout(() => {
          this.clearMsg();
          this.cdr.detectChanges();
        }, 3000);

      },
      error: (err) => {

        this.errorMessage = "Failed to create language";

        setTimeout(() => {
          this.clearMsg();
          this.cdr.detectChanges();
        }, 3000);

      }
    });

  }

  clearMsg() {
    this.successMessage = '';
    this.errorMessage = '';
  }

  addNew() {
    this.visibleButtonControl('Add');
    this.openModal();
  }

  refreshData(status: string, message: string) {

    if (status === "success") {
      this.successMessage = message;
      this.closeModal();
      this.loadLanguages();
      this.resetForm();
    } else {
      this.errorMessage = message;
    }

    setTimeout(() => {
      this.clearMsg();
      this.cdr.detectChanges();
    }, 3000);

  }

  exceptionData(message: string) {
    this.errorMessage = message;
    setTimeout(() => {
      this.clearMsg();
      this.cdr.detectChanges();
    }, 3000);
  }

  save() {

    this.clearMsg();

    const request: LanguageRequest = {
      code: this.code,
      name: this.name,
      isEnabled: this.isEnabled,
      icon: this.selectedFile || undefined
    };

    this.languageService.create(request).subscribe({
      next: (res) => {
        this.refreshData(res.status,res.message);
      },
      error: (err) => {
        this.exceptionData(err);
      }
    });

  }

  update() {

    this.clearMsg();

    const request: LanguageRequest = {
      languageId: this.languageId,
      code: this.code,
      name: this.name,
      isEnabled: this.isEnabled,
      icon: this.selectedFile || undefined
    };

    this.languageService.update(request).subscribe({

      next: (res) => {
        this.refreshData(res.status,res.message);
      },
      error: (err) => {
        this.exceptionData(err);
      }

    });

  }

  delete() {

    if (!confirm("Are you sure you want to delete this language?")) {
      return;
    }

    this.languageService.delete(this.languageId).subscribe({
      next: (res) => {
        this.refreshData(res.status,res.message);
      },
      error: (err) => {
        this.exceptionData(err);
      }
    });

  }

  resetForm() {
    this.code = '';
    this.name = '';
    this.selectedFile = null;
    this.isEnabled = false;
  }

}
